import React,{ useRef } from 'react';
import axios from 'axios'
import { Table, Input, Button,Collapse,Avatar,Modal,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon, { PrinterOutlined, MinusOutlined, CloseCircleFilled, CheckCircleOutlined, UserOutlined,LoadingOutlined } from '@ant-design/icons';
import { SearchOutlined,CameraOutlined,PlusOutlined } from '@ant-design/icons';
import QrReader from 'react-qr-reader'
import uuid from 'react-uuid'
import PhoneInput from 'react-phone-number-input'
import moment from 'moment';
import PrintTemplate from 'react-print';
import ReactToPrint from 'react-to-print';
import * as serverconfig from '../../views/serverconn'
import CurrencyFormat from 'react-currency-format';
import {
  Col,
  Row,
} from 'reactstrap';
import * as reactstrp from 'reactstrap';

const FormItem=Form.Item;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
const { Title } = Typography;
const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var token= ''


class ReportToPrint extends React.Component {

    state = {
      companyprofile:{},
    };
  
    componentDidMount(){
      if(localStorage.getItem("token")){
        token= localStorage.getItem("token")
     }else{
        token= ''
     }

      axios.defaults.headers={
        "Content-Type":"application/json",
        Authorization:`Token ${token}`
      }


      axios.get(`${serverconfig.backendserverurl}/api/companyprofile/${1}`)
      .then(res => {  
          this.setState({
            companyprofile: res.data
          })
  
      })

    }


    render() {
      return (
        <div style={{padding:20}}>
          <Row > 
                <Col xs="2" sm="2" lg="2">
                <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.company_logo} />
              
                </Col>
                <Col xs="6" sm="6" lg="6">
                <h3>{this.state.companyprofile.company_name}</h3>
                <h6>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
                </h6>               
                <h5>Email: {this.state.companyprofile.company_email}</h5>
                <h5>{this.state.companyprofile.box_number}</h5>
                </Col>
           </Row>
             <br></br> 
             <h2 style={{display: 'flex',justifyContent:'center', alignItems:'center',strong:true}}>{this.props.clientname} Transactions Report from {this.props.dateone}  to {this.props.datetwo}</h2>

             <reactstrp.Table bordered>
             <thead>
                <tr>
                  <th>Date</th>
                  <th>Phone</th>
                  <th>Transaction ID</th>
                  <th>Transaction Type</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
              {this.props.reportitems.map(
                (item)=>(
                  <tr>
                  <td>{item.date}</td>
                  <td>{item.Phone}</td>
                  <td>{item.transactionID}</td>
                  <td>{item.transactiontype}</td>
                  <td><CurrencyFormat value={item.Amount} displayType={'text'} thousandSeparator={true}  /></td>
                  </tr>
                ))}
                 <tr>                                      
                  <th>Totals</th>                                    
                  <td></td> 
                  <th><strong><CurrencyFormat value={this.props.totalamount} displayType={'text'} thousandSeparator={true}  /> </strong></th>  
                  <th></th>  
                  <td></td>                  
                  </tr>  
              </tbody>
            </reactstrp.Table>
        </div>
      );
    }
  }


class ClientTransactionstatement extends React.Component {

  state = {
    clients:[],
    reportitems:[],
    dateone:'',
    datetwo:'',
    client:'',
    clientname:'',
    totalamount:0,
    datarequested:true,
    country:'',
    currency:''
   };

   componentDidMount(){
    if(localStorage.getItem("token")){
      token= localStorage.getItem("token")
   }else{
      token= ''
   }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(serverconfig.backendserverurl+`/api/mobilemoneyclients/`)
    .then(res => {
        this.setState({
          clients:res.data
        })
        this.setState({datarequested:false})
      })

  }
 
   handledatechange= (date, dateString) =>{
     this.setState({ dateone: dateString[0]});
     this.setState({ datetwo: dateString[1]});
   } 

  handleclientChange= (e) =>{
    this.setState({ client: e});
    //get the vendor details
    axios.get(`${serverconfig.backendserverurl}/api/mobilemoneyclients/${e}`)
        .then(res => {  
            this.setState({
                clientname: res.data.client_name
            })
        })
  } 

 
   //search sales method
   searchSales=()=>{
    this.setState({reportitems:[]})
    this.setState({totalcredit:0})
    this.setState({totaldebit:0})
    
     //set loading state
     this.setState({datarequested:true})
    let form_data = new FormData();
    form_data.append('dateone', this.state.dateone);
    form_data.append('datetwo', this.state.datetwo);
    form_data.append('client', this.state.client);

    console.log(this.state.client)
      
    if(this.state.client===''){
      alert("Please select client")
    }else{

        //Now submit sale data to database
        axios.post(serverconfig.backendserverurl+'/customqueries/getclienttransactionsreport', form_data,{
        headers: {
          'content-type': 'multipart/form-data'
        }
        })
        .then(res =>{
           this.setState({datarequested:false})
            this.setState({reportitems:JSON.parse(res.data.report)})
            this.setState({totalamount:res.data.totalamount})
        } 
        )
        .catch(error => console.log(error))   
    }

    }

   ////////////////////////////////////
  // USER SEARCH SELECT METHODS
  onBlur=()=> {
    console.log('blur');
  }
  
   onFocus=()=>{
    console.log('focus');
  }
  
  onSearch=(val)=> {
    console.log('search:', val);
  }
 

   ////////////////////////////////////////////
   // RENDERING METHOD HERE
   render() {
       
    const columns = [
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
      },
      {
        title: 'Client',
        dataIndex: 'mobileclientname',
        key: 'id',
      },
      {
        title: 'Tel',
        dataIndex: 'Phone',
        key: 'id',
      },
        
      {
        title: 'Amount',
        dataIndex: 'Amount',
        key: 'id',
        render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
      },
      {
        title: 'Transaction Id',
        dataIndex: 'transactionID',
        key: 'id',
      },
      
      {
        title: 'Transaction Type',
        dataIndex: 'transactiontype',
        key: 'id',
      }, 
    ];
 
    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return(
        <div>
          <div style={{display: "none"}}>
             &nbsp;&nbsp;
            <ReportToPrint
            totalamount={this.state.totalamount} 
            dateone={this.state.dateone}
            datetwo={this.state.datetwo}
            columns={columns}
            reportitems={this.state.reportitems}
            clientname={this.state.clientname}
            ref={el => (this.componentRef = el)} /> 
          </div>

          <Collapse defaultActiveKey={['1']} onChange={this.callback}>
            <Panel header="CLIENT TRANSACTIONS REPORT" key="1">
            <Form  layout="inline" >

            <FormItem label="client">
                   <Select 
                   placeholder="client"
                   value={this.state.client} 
                   onChange={this.handleclientChange}
                   style={{width:300}}                                       
                   showSearch
                   optionFilterProp="children"
                   onFocus={this.onFocus}
                   onBlur={this.onBlur}
                   onSearch={this.onSearch}
                   filterOption={(input, option) =>
                     option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                   }   
                    >
                     {this.state.clients.map(
                       (itm)=>(
                         <Option value={itm.id}>{itm.client_name}</Option>
                       ))}
                   </Select>
               </FormItem>

                <FormItem label="Date Range">
                    <RangePicker defaultValue={moment()} onChange={this.handledatechange} format={dateFormat} />
                </FormItem>

                <FormItem>
                <Button onClick={this.searchSales} type="primary" htmlType="button">Search</Button>
                </FormItem> 

           </Form>

           <br></br>
            <Table columns={columns} 
            pagination={{showQuickJumper:true,showSizeChanger:true }}
            dataSource={this.state.reportitems}
            scroll={{ x: 1000 }}
           bordered/>  
            <br></br> 
            <Divider style={{borderColor:'red'}} dashed />

            <div style={{overflowX:'auto'}}>
            <Space>

               <h4>TOTAL AMOUNT: <CurrencyFormat value={this.state.totalamount} displayType={'text'} thousandSeparator={true}  />  </h4>
                &nbsp;&nbsp;
                <ReactToPrint
                trigger={() => 
                <Button type="primary"  shape="round" icon={<PrinterOutlined />} size={this.state.size}>
                Print
                </Button>
                }
                content={() => this.componentRef}
                />
            </Space>
           </div>

            </Panel>
            </Collapse>

        </div>

    )
    }
 
     
   }
}

export default ClientTransactionstatement; 
